import { Icon } from '@/kit/Icon';
import { DialogClose, DialogContent } from '@/kit/dialog';

/**
 * Angular `ConfirmationDialogComponent` of Update Directors: resolves true (Ok) or undefined (X / backdrop / Escape).
 * There is no Cancel button, like the original.
 */
export function ConfirmationDialog() {
  return (
    <div className="mat-dialog-wrapper">
      <DialogContent>
        <div className="main-contain">
          <div className="sidenav-header">
            <div className="d-flex align-items-center justify-space-between">
              <h2>
                <span>Confirmation</span>
              </h2>
              <DialogClose>
                <Icon name="close" className="close" />
              </DialogClose>
            </div>
          </div>
        </div>
        <div>
          <p className="font-size-14 w-550">
            Please note that if you proceed with bulk update, it will replace all your existing directors with the most
            up to date data from Companies house.
          </p>
        </div>
      </DialogContent>

      <div className="d-flex gap-15 hr-top pt-1 mt-1">
        <DialogClose as="button" result={true} type="button" className="action-button primary-button">
          Ok
        </DialogClose>
      </div>
    </div>
  );
}
